import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Button, Avatar, Icon, Collapse, Tooltip, Radio, Popconfirm, message, Input, Table, Modal, Steps } from 'antd';
import {
  DetailsCard,
  UserProfilecover,
  UserDetailHeadingCover,
  TeamDetailsCard,
  ChangeSmtpRadio,
  FlexContainter,
  DomainContainer,
  AdddDomainContainter,
  InputLabel,
  DetailCardContainer,
  InvalidError,
  VerifyButton,
  DefaultDomain, ActionButton
} from './styles';
import Loader from '../../components/Loader';
import { LoginContainer } from '../../components/Modals/styles';
import {
  getAllSMTPConfig, changeDefaultSMTP, createNewDomain, VerifyDomain, DeleteDomain, fetchDomainList,
  createFromAddress, getAllFromAddress, deleteSMTPConfig, validateSMTPConfig,
} from '../../utils/services/smtpConfigAPI';
import { SMTPConfigModal } from '../../components/Modals';
import DeleteSMTPConfigModal from '../../components/Modals/DeleteSMTPConfigModal';
import { withTranslation } from 'react-i18next';
import { MANAGE_SMTP_SERVER_CONFIGURATION as trans } from './TranslationValues';
import { AppStoreContext } from '../../context/appStoreContext';
import FromAddressTable from './FromAddressTable';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage'
import { Spin } from 'antd';
import Regex from '../../utils/regex';
import { ENTERPRISE_ENV } from '../../utils/helper'

const NAMESPACE = ['MANAGE_SMTP_SERVER_CONFIGURATION'];
const SMTPServerConfig = props => {
  const { t } = props;
  const { planType } = useContext(AppStoreContext);
  const { Search } = Input;
  const { Step } = Steps;
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [deleteModalVisible, setDeleteModalVisible] = useState(null);
  const [changeDefault, isChangeDefault] = useState(false);
  const [defaultSMTPID, setDefaultSMTPID] = useState(null);
  const [serverUserDetails, setServerUserDetails] = useState([]);

  const [fromAddress, setFromAddress] = useState('');
  const [domainId, setDomainId] = useState('');
  const [step, setStep] = useState('0');
  const [addressList, setAddressList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [selector, setSelector] = useState({ public: "", selector: "" });
  const [loadingData, setLoadingData] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  const [SMTPConfigList, setSMTPConfigList] = useState([]);
  const [serverId, setServerID] = useState('');
  const [awaitingApiResponse, setAwaitingApiResponse] = useState(false);
  const { Panel } = Collapse;

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await getAllSMTPConfig('');
      const allFromAddress = await getAllFromAddress('verified,unverified');
      setSMTPConfigList(allFromAddress?.data);
      if (response && response?.errors && response?.errors.length === 0) {
        const result = response?.data.sort((a, b) => b.sparkPost - a.sparkPost);
        setServerUserDetails(result);
      }
    } catch (e) {
      console.log('error', e);
    }

    setLoading(false);
  };

  const onSuccess = () => {
    setShowModal(false);
    setIsEditing(false);
    fetchData();
  };

  const handleDelete = isDeleted => {
    setDeleteModalVisible(false);
    if (isDeleted) {
      fetchData();
    }
  };

  const defaultChange = async e => {
    isChangeDefault(false);
    let response = await changeDefaultSMTP(e);
    if (response?.statusCode === 1115) {
      message.success(t(trans.DEFAULT_SMTP_UPDATED_SUCCESFULLY.key, trans.DEFAULT_SMTP_UPDATED_SUCCESFULLY.value));
      fetchData();
    } else {
      message.error(t(trans.UNABLE_TO_UPDATE_DEFAULT_SMTP.key, trans.UNABLE_TO_UPDATE_DEFAULT_SMTP.value));
    }
  };

  const showAddDomainModal = (id) => {

    setFromAddress('');
    setServerID(id);

    if (planType === "Free" && !ENTERPRISE_ENV) {
      message.error(t(trans.FREE_PLAN_CANNOT_ADD_DOMAIN_ERROR.key, trans.FREE_PLAN_CANNOT_ADD_DOMAIN_ERROR.value));
      return;
    }

    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // create new domain
  // create new from address
  const handleAddDomain = async () => {
    setActiveKey([]);
    const isValidEmail = Regex.EMAIL.test(fromAddress);

    if (!isValidEmail) {
      message.error(t(trans.INVALID_FROM_ADDRESS_ERROR.key, trans.INVALID_FROM_ADDRESS_ERROR.value));
      return;
    };

    const defaultAddress = serverUserDetails.find((list) => list.id === serverId);

    if (ENTERPRISE_ENV && !defaultAddress.sparkPost) {
      const payLoad = {
        "emailFromAddress": fromAddress,
        "sMTPServerConfig": {
          "id": serverId
        },
      };

      setIsLoading(true);
      const response = await createFromAddress(payLoad);
      response?.data && setSMTPConfigList([...SMTPConfigList, response.data]);
      setIsModalOpen(false)
      setIsLoading(false);
      return;
    }

    const domain = fromAddress.split('@').pop();
    const result = addressList.findIndex((list) => list.domain === domain);

    if (!ENTERPRISE_ENV && result < 0 && ((planType === "Standard" && addressList.length === 1) || (planType === "Premium" && addressList.length === 2))) {
      message.error(planType === "Standard" ? t(trans.STANDARD_PLAN_LIMIT_REACHED_ERROR.key, trans.STANDARD_PLAN_LIMIT_REACHED_ERROR.value) : t(trans.PREMIUM_PLAN_LIMIT_REACHED_ERROR.key, trans.PREMIUM_PLAN_LIMIT_REACHED_ERROR.value));
      return;
    }

    if (result >= 0) {
      const id = addressList[result].id
      const payLoad = {
        "emailFromAddress": fromAddress,
        "sMTPServerConfig": {
          "id": serverId
        },
        "domainId": {
          "id": id
        }
      };

      setIsLoading(true);
      const response = await createFromAddress(payLoad);
      if (response?.statusCode === 2402) {
        const errorCode = response.errors[0].code;
        if (errorCode === 1705) {
          message.error(t(trans.FROM_ADDRESS_LIMIT_REACHED.key, trans.FROM_ADDRESS_LIMIT_REACHED.value));
        } else {
          message.error(t(trans.FAILED_TO_ADD_FROM_ADDRESS.key, trans.FAILED_TO_ADD_FROM_ADDRESS.value));
        }

        setIsLoading(false);
        return;
      }
      response?.data && setSMTPConfigList([...SMTPConfigList, response.data]);
    } else {
      setIsLoading(true);
      const domainResponse = await createNewDomain(domain.toLowerCase());
      console.log('domainResponse', domainResponse)
      if (domainResponse.id) {
        const payLoad = {
          "emailFromAddress": fromAddress,
          "sMTPServerConfig": {
            "id": serverId
          },
          "domainId": {
            "id": domainResponse.id
          }
        };

        const fromAddressResponse = await createFromAddress(payLoad);

        const PayLoad = [{
          ...domainResponse.data.results,
          id: domainResponse.id,
          status: 'unverified',
        }];
        console.log('PayLoad', PayLoad)
        setAddressList([...addressList, ...PayLoad]);
        fromAddressResponse?.data && setSMTPConfigList([...SMTPConfigList, fromAddressResponse.data])
      }
    };

    setIsModalOpen(false)
    setIsLoading(false);
  };

  //  verify the domain address
  const handleBtn = async () => {
    setIsLoading(true);
    const verifyDomainStatus = await VerifyDomain(selector.domain_id);
    if (verifyDomainStatus?.data) {
      setIsModalOpen(false);

      const updateStatus = addressList.map((list) => {
        if (list.id === selector.domain_id) {
          list.status = 'verified'
        }
        return list;
      });
      setAddressList([...updateStatus]);
    }
    else {
      message.error(t(trans.HOSTNAME_VALUE_VERIFY_ERROR.key, trans.HOSTNAME_VALUE_VERIFY_ERROR.value));
    }
    setIsLoading(false);
  }

  // Delete domain
  const handleDeleteDomain = async (id) => {
    setDomainId(id)
    setLoadingData(true);
    const response = await DeleteDomain(id);

    if (response?.statusCode === 2418) {
      const remove_domain = addressList.filter((list) => list.id !== id);
      setAddressList([...remove_domain])
    }
    setLoadingData(false);
  };

  const updateDomain = async (id, dnsValue) => {
    showAddDomainModal();
    setStep('1');

    if (dnsValue?.public) {
      setSelector({ selector: dnsValue.selector, public: dnsValue.public, domain_id: id });
    } else {
      const data = JSON.parse(dnsValue);
      const public_value = data.results.dkim.public;
      const selector = data.results.dkim.selector;
      setSelector({ selector: selector, public: public_value, domain_id: id });
    };
  }

  const deleteSMTP = async (id) => {
    const payload = { "id": id };
    const response = await deleteSMTPConfig(payload);

    if (response && response?.statusCode === 1107) {
      const removeSmtp = serverUserDetails.filter((list) => list.id !== id);
      setServerUserDetails([...removeSmtp]);
      message.success(t(trans.SMTP_CONFIG_REMOVED_SUCCESSFULLY.key, trans.SMTP_CONFIG_REMOVED_SUCCESSFULLY.value));
    } else {
      message.error(t(trans.FAILED_TO_DELETE_SMTP_CONFIGURATION.key, trans.FAILED_TO_DELETE_SMTP_CONFIGURATION.value));
    }

  }

  // Get all domain list 
  useEffect(() => {
    const getDomainList = async () => {
      const result = await fetchDomainList();
      if (result && result?.data) {
        setAddressList([...addressList, ...result.data]);
      }
    };
    getDomainList();
  }, []);

  // This function copies the API key to the clipboard.
  const copyApiKey = (data) => {
    navigator.clipboard.writeText(data);
    message.success(t(trans.COPIED_INFO_MESSAGE.key, trans.COPIED_INFO_MESSAGE.value));
  };

  const addressTable = (value, type) => {
    let list;
    if (type === 'smtp') {
      list = SMTPConfigList.filter((list) => list.sMTPServerConfig.id === value.id);
    } else {
      list = SMTPConfigList.filter((list) => list.domainId?.id === value?.id);
    };

    return (
      <FromAddressTable domainId={null} key={null} fromAddressList={list} t={t} />
    )
  };

  const validateConfig = useCallback(async value => {
    try {
      setAwaitingApiResponse(true);
      const response = await validateSMTPConfig(value);
      if (response?.statusCode === 1000) {
        message.success(t(trans.SMTP_VALIDATION_SUCCESS_MESSAGE.key, trans.SMTP_VALIDATION_SUCCESS_MESSAGE.value));
        fetchData();
      } else {
        message.error(t(trans.SMTP_VALIDATION_ERROR_MESSAGE.key, trans.SMTP_VALIDATION_ERROR_MESSAGE.value));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setAwaitingApiResponse(false);
    }
  }, []);

  const renderList = () => {
    return (
      <Collapse accordion style={{ maxHeight: "none" }} >
        {serverUserDetails &&
          serverUserDetails.map((value, key) => {
            return (
              <Panel
                // disabled={true}   
                style={{ maxHeight: "none" }}
                key={key}
                showArrow={false}
                header={
                  <DetailsCard key={key} smtp={1}>
                    {changeDefault && (
                      <Radio.Group
                        onChange={e => setDefaultSMTPID(value.id)}
                        value={value.default ? value.id : defaultSMTPID}
                      >
                        {value.default ? (
                          <Radio value={value.id} />
                        ) : (
                          <Popconfirm
                            title={
                              <ChangeSmtpRadio>
                                {t(trans.CHANGE_DEFAULT_SMTP_SERVER_CONFIRMATION_POPUP_TITLE.key, trans.CHANGE_DEFAULT_SMTP_SERVER_CONFIRMATION_POPUP_TITLE.value)}
                              </ChangeSmtpRadio>
                            }
                            onConfirm={() => defaultChange(defaultSMTPID)}
                            onCancel={() => isChangeDefault(false)}
                            okText={t(trans.CONFIRM_DEFAULT_SMTP_SERVER_BUTTON.key, trans.CONFIRM_DEFAULT_SMTP_SERVER_BUTTON.value)}
                            cancelText={t(trans.DECLINE_DEFAULT_SMTP_SERVER_BUTTON.key, trans.DECLINE_DEFAULT_SMTP_SERVER_BUTTON.value)}
                          >
                            <Radio value={value.id} />
                          </Popconfirm>
                        )}
                      </Radio.Group>
                    )}

                    <UserProfilecover permission={true}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '50%',
                        }}
                      >
                        <Avatar className="avatar">{value?.userName && value?.userName?.charAt(0)?.toUpperCase()}</Avatar>
                        <p>{value.userName}</p>
                      </div>
                    </UserProfilecover>

                    {value.default && (
                      <Tooltip
                        placement="top"
                        title={!changeDefault ? t(trans.CHANGE_DEFAULT_SMTP_SERVER_TOOLTIP.key, trans.CHANGE_DEFAULT_SMTP_SERVER_TOOLTIP.value) : t(trans.CURRENT_DEFAULT_SMTP_SERVER_TOOLTIP.key, trans.CURRENT_DEFAULT_SMTP_SERVER_TOOLTIP.value)}
                      >
                        <div className="defaultSmtp" onClick={() => isChangeDefault(true)}>
                          {t(trans.CHANGE_DEFAULT_SMTP_SERVER_ACTION.key, trans.CHANGE_DEFAULT_SMTP_SERVER_ACTION.value)}
                        </div>
                      </Tooltip>
                    )}
                  </DetailsCard>
                }
                extra={
                  <div
                    style={{
                      display: 'flex',
                      columnGap: '10px',
                      alignItems: 'center',
                      cursor: changeDefault && 'not-allowed',
                      marginRight: "10px"
                    }}
                    onClick={e => e.stopPropagation()}
                  >
                    {value.status === 'Idle' ? (
                      <VerifyButton onClick={() => validateConfig(value)} verify delete>{awaitingApiResponse && <Icon type='loading'/>} {t(trans.VALIDATE_BUTTON.key, trans.VALIDATE_BUTTON.value)}</VerifyButton>
                    ) : (
                      <ActionButton smtp={1}>
                        <Button
                          type="primary"
                          className="add_user_btn"
                          onClick={() => showAddDomainModal(value.id)}
                        >
                          {t(trans.ADD_FROM_ADDRESS_TEXT.key, trans.ADD_FROM_ADDRESS_TEXT.value)}
                        </Button>
                      </ActionButton>
                    )}
                    <Popconfirm
                      title={t(
                        trans.DELETE_CONFIRMATION_MESSAGE.key,
                        trans.DELETE_CONFIRMATION_MESSAGE.value,
                      )}
                      onConfirm={event => {
                        deleteSMTP(value.id);
                        event.stopPropagation();
                      }}
                      cancelText={t(
                        trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.key,
                        trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.value,
                      )}
                      okText={t(
                        trans.MANAGE_SMTP_SERVER_OK_LABEL.key,
                        trans.MANAGE_SMTP_SERVER_OK_LABEL.value,
                      )}
                      okButtonProps={{style: {width: 'fit-content'}}}
                      cancelButtonProps={{style: {width: 'fit-content'}}}
                    >
                      {!value.sparkPost && <VerifyButton delete >{t(trans.DELETE_BUTTON.key, trans.DELETE_BUTTON.value)}</VerifyButton>}
                    </Popconfirm>
                  </div>
                }
              >
                <DefaultDomain>
                  <div style={{ padding: "0px 0px 16px 30px" }}> {value.emailFromAddress}</div>
                </DefaultDomain>

                {value.sparkPost ?
                  <DetailCardContainer>
                    {addressList?.length !== 0 && addressList.map((list, index) => {

                      return (
                        <Collapse
                          key={index}
                          bordered={false}
                          className="site-collapse-custom-collapse collapse-card-style"
                          onChange={(data) => setActiveKey(data[data.length - 1])}
                          activeKey={activeKey}
                        >
                          <Panel
                            key={index}
                            header={list.domain}
                            className="site-collapse-custom-panel "
                            extra={
                              <div style={{
                                display: 'flex',
                                columnGap: '10px',
                                alignItems: 'center',
                                cursor: changeDefault && 'not-allowed',
                                marginRight: "10px"
                              }}
                                onClick={e => e.stopPropagation()}>

                                {domainId === list.id && loadingData && <div className='center-screen'><Spin /></div>}
                                <Tooltip title={t(trans.VERIFY_BUTTON_TOOLTIP.key, trans.VERIFY_BUTTON_TOOLTIP.value)} trigger="hover" >
                                  {list.status === 'unverified' && <VerifyButton delete verify onClick={() => { updateDomain(list.id, list.dnsValue ? list.dnsValue : list.dkim) }}>{t(trans.VERIFY_BUTTON.key, trans.VERIFY_BUTTON.value)}</VerifyButton>}
                                </Tooltip>

                                <Popconfirm title={t(trans.DELETE_CONFIRMATION_MESSAGE.key, trans.DELETE_CONFIRMATION_MESSAGE.value)} onConfirm={(event) => {
                                  handleDeleteDomain(list.id);
                                  event.stopPropagation();
                                }} >
                                  {list.status === 'unverified' && <VerifyButton delete >{t(trans.DELETE_BUTTON.key, trans.DELETE_BUTTON.value)}</VerifyButton>}
                                </Popconfirm>
                              </div>}
                          >
                            {addressTable(list, 'address')}
                          </Panel>
                        </Collapse>
                      )
                    })}
                  </DetailCardContainer>
                  :
                  addressTable(value, 'smtp')
                }
              </Panel>
            );
          })}
      </Collapse>
    );
  };

  return (
    <>
      <Modal title={step === '0' ? t(trans.ADD_FROM_ADDRESS_TEXT.key, trans.ADD_FROM_ADDRESS_TEXT.value) : t(trans.VERIFY_DOMAIN_MODAL_TITLE.key, trans.VERIFY_DOMAIN_MODAL_TITLE.value)} visible={isModalOpen} onOk={handleOk} onCancel={handleCancel} closable={false}
        className="add-smtp-server"
        footer={
          <div style={{ marginTop: "25px" }}>
            <Button
              className='footer-btn'
              key="Add User"
              type="primary"
              onClick={() => {
                setIsModalOpen(false);
                setStep('0')
              }
              }
              style={{ maxWidth: "30%", minWidth: "30%" }}
            >
              {t(trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.key, trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.value)}
            </Button>,

            <Button
              loading={isloading}
              className='footer-btn'
              style={{ maxWidth: "30%", minWidth: "30%" }}
              key="Add User"
              type="primary"
              onClick={() => {
                step === "0" ? handleAddDomain() : handleBtn("3");
              }}
            >
              {step === "0" ? t(trans.ADD_FROM_ADDRESS_BUTTON.key, trans.ADD_FROM_ADDRESS_BUTTON.value) : t(trans.DOMAIN_VERIFY_BUTTON.key, trans.DOMAIN_VERIFY_BUTTON.value)}
            </Button>
          </div>
        }
      >

        <AdddDomainContainter>
          {
            step === '0' ?
              <>
                <Search
                  placeholder={t(trans.ENTER_FROM_ADDRESS_PLACEHOLDER.key, trans.ENTER_FROM_ADDRESS_PLACEHOLDER.value)}
                  allowClear
                  size="large"
                  onChange={(e) => { setFromAddress(e.target.value) }}
                  value={fromAddress}
                />
              </>
              :
              <div>
                <div className='alert-message'>
                  {t(trans.ADD_HOSTNAME_ALERT_MESSAGE.key, trans.ADD_HOSTNAME_ALERT_MESSAGE.value)}
                </div>
                <InputLabel>
                  {t(trans.DNS_HOSTNAME_LABEL.key, trans.DNS_HOSTNAME_LABEL.value)}
                </InputLabel>
                <Input
                  name="licenseKey"
                  className='input'
                  size="large"
                  readOnly={true}
                  value={selector.selector}
                  addonAfter={
                    <Tooltip
                      title={t(trans.COPY_TO_CLIPBOARD_TOOLTIP.key, trans.COPY_TO_CLIPBOARD_TOOLTIP.value)}
                      trigger="hover"
                    >
                      <div className="copy-button" onClick={() => copyApiKey(selector.selector)}>
                        <Icon type={'copy'} />{' '}
                        <p>{t(trans.DNS_PROVIDER_COPY_BUTTON.key, trans.DNS_PROVIDER_COPY_BUTTON.value)}</p>
                      </div>
                    </Tooltip>
                  }
                />
                <InputLabel>
                  {t(trans.DNS_VALUE_LABEL.key, trans.DNS_VALUE_LABEL.value)}
                </InputLabel>
                <Input
                  name="licenseKey"
                  size="large"
                  readOnly={true}
                  value={selector.public}
                  addonAfter={
                    <Tooltip
                      title={t(trans.COPY_TO_CLIPBOARD_TOOLTIP.key, trans.COPY_TO_CLIPBOARD_TOOLTIP.value)}
                      trigger="hover"
                    >
                      <div className="copy-button" onClick={() => copyApiKey(selector.public)}>
                        <Icon type={'copy'} />{' '}
                        <p>{t(trans.DNS_PROVIDER_COPY_BUTTON.key, trans.DNS_PROVIDER_COPY_BUTTON.value)}</p>
                      </div>
                    </Tooltip>
                  }
                />
              </div>
          }
        </AdddDomainContainter>

      </Modal>
      {loading ? (
        <LoginContainer>
          <Loader />
        </LoginContainer>
      ) : (
        <>
          <UserDetailHeadingCover separator>
            <div>
              <h5>{t(trans.MANAGE_SMTP_SERVER_CONFIGURATION_TITLE.key, trans.MANAGE_SMTP_SERVER_CONFIGURATION_TITLE.value)}</h5>
              <p>{t(trans.MANAGE_SMTP_SERVER_CONFIGURATION_DESCRIPTION.key, trans.MANAGE_SMTP_SERVER_CONFIGURATION_DESCRIPTION.value)}</p>
            </div>

            { ENTERPRISE_ENV &&
              <Button
                type="primary"
                className="add_user_btn"
                onClick={() => {
                  if (!changeDefault) {
                    setShowModal(true);
                    setSelectedItem({});
                    setIsEditing(false);
                  } else {
                    isChangeDefault(false);
                  }
                }}
              >
                {!changeDefault ? t(trans.ADD_NEW_SMTP_SERVER_CONFIGURATION_MODAL_BUTTON.key, trans.ADD_NEW_SMTP_SERVER_CONFIGURATION_MODAL_BUTTON.value) : t(trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.key, trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.value)}
              </Button>
            }
          </UserDetailHeadingCover>
          <TeamDetailsCard smtp={1} default={changeDefault} teams key={SMTPConfigList.length}>
            {renderList()}
          </TeamDetailsCard>
          {showModal && (
            <SMTPConfigModal
              onCancel={() => {
                setShowModal(false);
                setIsEditing(false);
              }}
              onSuccess={onSuccess}
              isEditing={isEditing}
              selectedItem={selectedItem}
              target={selectedItem}
            />
          )}


          {deleteModalVisible && (
            <DeleteSMTPConfigModal
              visible={deleteModalVisible}
              targetUser={selectedItem}
              onCancel={handleDelete}
              isDeleteSMTP={true}
            />
          )}

        </>
      )}
    </>
  );
};
export default withTranslation(NAMESPACE)(SMTPServerConfig);
